const options = [
  {
    label: "Routine",
    time: "6–8 Weeks",
    fee: "$130",
    agency: false,
    best: false,
    desc: "Standard government processing for non-urgent travel. Fine for trips planned months in advance.",
  },
  {
    label: "Expedited (Gov)",
    time: "2–3 Weeks",
    fee: "$185",
    agency: false,
    best: false,
    desc: "Government expedited processing. Best for travel 3+ weeks out. No appointment required for renewals.",
  },
  {
    label: "Fast Passport Center",
    time: "24–72 Hours",
    fee: "From $259 total",
    agency: true,
    best: true,
    desc: "Our registered courier service submits directly at the Kansas City Regional Agency with reserved slots — no appointment race, no 45-minute commute each way to Downtown KC.",
  },
];

export default function LeeSummitProcessingTimeSection() {
  return (
    <section id="processing-options" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Processing Options</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How Fast Can You Get Your Passport from Lee&apos;s Summit?
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            The Kansas City Regional Passport Agency is 25 minutes away — but walk-in appointments are limited and competition is fierce. Our reserved courier slots bypass the appointment race entirely.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {options.map((opt, i) => (
            <div
              key={i}
              className={`relative rounded-lg border p-8 flex flex-col ${
                opt.best
                  ? "border-[#F6C344] bg-[#1A365D] text-white"
                  : "border-gray-200 bg-white"
              }`}
            >
              {opt.best && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#F6C344] text-[#1A365D] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                  Recommended for Lee&apos;s Summit
                </span>
              )}
              <h3 className={`font-bold text-lg mb-1 ${opt.best ? "text-[#F6C344]" : "text-[#1A365D]"}`}>
                {opt.label}
              </h3>
              <p className={`text-3xl font-bold mb-1 ${opt.best ? "text-white" : "text-[#1A365D]"}`}>{opt.time}</p>
              <p className={`text-sm mb-4 ${opt.best ? "text-white/60" : "text-gray-400"}`}>{opt.fee}</p>
              <p className={`text-sm leading-relaxed flex-1 ${opt.best ? "text-white/80" : "text-gray-500"}`}>{opt.desc}</p>
              {opt.best && (
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="mt-6 inline-flex items-center justify-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
                >
                  Get Started <i className="ri-arrow-right-line"></i>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}